import {LocalDate} from '@js-joda/core';

/** Внутренние календарные расчёты; не зависят от утилит приложения-потребителя. */
export class CalendarDateUtil {
  /** Недели месяца с понедельника; соседние месяцы представлены пустыми ячейками. */
  public static weeks(date: LocalDate): (LocalDate | null)[][] {
    const first = date.withDayOfMonth(1);
    const offset = first.dayOfWeek().value() - 1;
    const count = Math.ceil((offset + first.lengthOfMonth()) / 7) * 7;
    const weeks: (LocalDate | null)[][] = [];
    for (let index = 0; index < count; index++) {
      if (index % 7 === 0) {
        weeks.push([]);
      }
      const day = index - offset + 1;
      weeks[weeks.length - 1].push(day > 0 && day <= first.lengthOfMonth() ? first.withDayOfMonth(day) : null);
    }
    return weeks;
  }

  /** Клавиатурная навигация без изменения выбранного значения. */
  public static navigate(date: LocalDate, key: string): LocalDate | null {
    switch (key) {
      case 'ArrowLeft':
        return date.minusDays(1);
      case 'ArrowRight':
        return date.plusDays(1);
      case 'ArrowUp':
        return date.minusDays(7);
      case 'ArrowDown':
        return date.plusDays(7);
      case 'Home':
        return date.minusDays(date.dayOfWeek().value() - 1);
      case 'End':
        return date.plusDays(7 - date.dayOfWeek().value());
      case 'PageUp':
        return date.minusMonths(1);
      case 'PageDown':
        return date.plusMonths(1);
      default:
        return null;
    }
  }
}
